'use strict';
import {ClientCaseId} from './framework/domain/client-case-id';

export const ENABLE_DIRECT_LOGIN = false;
export const ENABLE_OAUTH2_LOGIN = false;
export const JUDGEMENT_TYPE_PREFERENCE = [0, 1, 2];
export const ENABLE_PADDING = false;
export const PARTIAL_CASE_ENABLED = true;
export const CASE_ID_MAIN_SEPARATOR = ' ';
export const CASE_ID_PARTIAL_SEPARATOR = ' ';
export const CASE_ID_MAIN_PARTIAL_SEPARATOR = ' ';
export const LOGIHECK_SSO_URL = '/api/oauth2/authorization/logicheck';
/*export const CLIENT_CASE_ID_MODEL = {
    idComponentsConfiguration: [
        {
            type: 'TEXT',
            separatorIndex: 1,
            separatorSpan: 2,
            maxLength: 20,
            requiredLength: 12,
            restrict: '[0-9-]',

            padSettings: {
                padChar: '0',
                padDirection: 'left'
            },
            isValid: function (value: any) {
                if (typeof value === 'number') {
                    value = value.toString();
                }
                return !!(value &&
                    value.length >= this.requiredLength &&
                    value.length <= this.maxLength);
            }
        }]
    ,
    idPartialsConfiguration: [{
        separatorIndex: 3,
        separatorSpan: 1,
        type: 'TEXT',
        maxLength: 24,
        requiredLength: 1,
        restrict: '[0-9a-zA-Z]',
        isValid: function (value: any) {
            if (typeof value === 'number') {
                value = value.toString();
            }
            return !!(value &&
                value.length >= this.requiredLength &&
                value.length <= this.maxLength);
        }
    }]
};*/
export const CLIENT_CASE_ID_MODEL = {
    idComponentsConfiguration: [{
        type: 'TEXT',
        maxLength: 11,
        requiredLength: 10,
        restrict: '[0-9KRDHFEkrdhfe]',
        isValid: function (value: any) {
            if (typeof value === 'number') {
                value = value.toString();
            }
            return !!(value &&
                value.length >= this.requiredLength &&
                value.length <= this.maxLength);
        }
    }]
    ,
    idPartialsConfiguration: [{
        separatorIndex: 3,
        separatorSpan: 1,
        type: 'TEXT',
        maxLength: 24,
        requiredLength: 1,
        restrict: '[0-9a-zA-Z ]',
        isValid: function (value: any) {
            if (typeof value === 'number') {
                value = value.toString();
            }
            return !!(value &&
                value.length >= this.requiredLength &&
                value.length <= this.maxLength);
        }
    }]
};

export const ON_CASE_ID_CHANGE = function (clientCaseId: ClientCaseId, model: any) {
    /*let thirdInputMaxLength = 6;
    const value = clientCaseId.main[0];
    const optArr = ['AS', 'AR', 'VM', 'FO', 'BG', 'OP', 'TE'];
    let secondInputConfiguration: string;

    if (value !== undefined && value !== null && value !== '') {
        if (optArr.indexOf(value) !== -1) {
            secondInputConfiguration = 'options2';
            thirdInputMaxLength = 8;
        } else {
            secondInputConfiguration = 'options1';
        }

    } else {
        clientCaseId.main.forEach(function (configurationOption) {
            configurationOption = '';
        });
    }

    if (mainComponentConfiguration.activeList !== secondInputConfiguration) {
        mainComponentConfiguration[1].activeList = secondInputConfiguration;
        mainComponentConfiguration[2].maxLength = thirdInputMaxLength;
        mainComponentConfiguration[2].requiredLength = thirdInputMaxLength;
    }*/
};

export const SSO_LOGIN_URL = 'https://URL/authenticationServer/rest/auth/api/authorize?response_type=code&client_id=5e3e2a10-d4a9-4572-9a71-196d2300150f&redirect_uri=http://localhost:4200/login&state=xyz&scope=/F///FUNC/2000803028///X';

export const DIRECTLOGINCASEPARAMS = [
    {param: 'grunddaten_anmietstationPlz', path: 'zipCode', tabState: 'INVOICE_DATA'},
    {param: 'grunddaten_kmStandAnmietung', path: 'rentalDistanceStart', tabState: 'INVOICE_DATA'},
    {param: 'grunddaten_kmStandAbgabe', path: 'rentalDistanceEnd', tabState: 'INVOICE_DATA'},
    {param: 'kosten_gesamtkostenNetto', path: 'invoiceAmount', tabState: 'INVOICE_DATA'},
    {param: 'grunddaten_datumAnmietung', path: 'rentalDate', tabState: 'RENTAL_DURATION'},
    {param: 'grunddaten_uhrzeitDerAnmietung', path: 'rentalTime', tabState: 'RENTAL_DURATION'},
    {param: 'grunddaten_datumRueckgabe', path: 'dueDate', tabState: 'RENTAL_DURATION'},
    {param: 'grunddaten_uhrzeitRueckgabe', path: 'dueTime', tabState: 'RENTAL_DURATION'},
    {param: 'kosten_abholung', path: 'abholen', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_zustellung', path: 'zustellen', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_haftungsreduzierung', path: 'haftungsreduzierung', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_zusatzfahrer', path: 'zusatzfahrer', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_navigationsgeraet', path: 'navigationsgeraet', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_winterreifen', path: 'winterreifen', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_betankung', path: 'betankung', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_innenraumSchutz', path: 'innenraumSchutz', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_personenUnfall', path: 'personenUnfall', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_mobilitaetsservice', path: 'mobilitaetsservice', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_nebenkostenPauschale', path: 'nebenkostenPauschale', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_anhaengerkupplung', path: 'anhaengerkupplung', tabState: 'ADDITIONAL_COSTS'},
    {param: 'kosten_automatik', path: 'automatik', tabState: 'ADDITIONAL_COSTS'},
];
